export default __webpack_public_path__ + "static/media/beginwithC++Img.441bca08.png";